/**
 * DFT-0033: page 11's design shows a colored status dot, not plain text.
 *
 * DFT-0027 (Slice E): extracted out of useBayHireRequestList so the vendor
 * request list AND the Operations Ongoing/Waiting-list queues share one
 * mapping (all three now render the same Figma status column).
 *
 * DFT-0098: this is now also BayHireRequestDetail.tsx's own single source of
 * truth for status color (its own separate getStatusChipColor/getStatusDotColor
 * mapping - which disagreed with this one for REQUESTED/CANCELLED - is gone).
 * REQUESTED -> warning (was neutral), CANCELLED -> error (was warning, shared
 * with WAITING_LIST, which stays warning).
 *
 * Consumers must pass the result to the row's `badgeType` field and use a
 * header whose field is literally "status" (not renderAsChip) - see
 * components/DataTable/columns.tsx, which prefers `row.badgeType` over its
 * own generic getBadgeType (that only recognizes human-readable statuses
 * like "Approved", never Bay Hire's raw domain values like "APPROVED").
 */
export const getBayHireStatusBadgeType = (
  status?: string,
): "success" | "warning" | "error" | "neutral" => {
  switch (status) {
    case "PRE_APPROVED":
    case "PAYED":
    case "APPROVED":
      return "success";
    case "REJECTED":
    case "CANCELLED":
      return "error";
    case "WAITING_LIST":
      return "warning";
    case "REQUESTED":
      return "warning";
    default:
      return "neutral";
  }
};
